import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDHeadlineText } from '@facet-wealth/design';

export const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['scenarioName'], {
    _component: FDHeadlineText,
    _customProps: {
      color: 'textSecondary',
      size: 'sm',
      align: 'center',
    },
  }, overrideReadOnly);
